import { Auth0Provider } from "@auth0/auth0-react";
import React, { useEffect } from "react";
import { ServiceProvider } from "../contexts/ServiceContext";
import { TealiumUTagLoader } from "../integrations/Tealium";
import { getEnv } from "../utils/getEnv";
import mixpanel from "mixpanel-browser";

// const onRedirectCallback = (appState) => navigate(appState?.returnTo || '/');
// const onRedirectCallback = (appState: any) => console.log('DO SOMETHING AHHH', appState);

type ServiceWrapperProps = {
    children?: React.ReactNode;
    deployType?: DeployTypes;
    tenantSlug: string;
    alternateTheme?: boolean;
};

export type DeployTypes = "edge" | "embed" | "standalone";

export const ServiceWrapper = ({
    children,
    deployType,
    tenantSlug,
    alternateTheme,
}: ServiceWrapperProps): JSX.Element => {
    const appType = deployType ?? "standalone";

    // calculate redirect url based on embed type
    const redirectUri = ((t: DeployTypes) => {
        if (t === "edge" || t === "embed") {
            return window.location.toString();
        }
        // ok - we must be standalone!
        return `${window.origin}/callback`;
    })(appType);

    useEffect(() => {
        mixpanel.init(getEnv().REACT_APP_MIXPANEL_TOKEN ?? "");
    }, []);

    return (
        <Auth0Provider
            domain={getEnv().REACT_APP_AUTH0_DOMAIN}
            clientId={getEnv().REACT_APP_AUTH0_CLIENT_ID}
            audience={getEnv().REACT_APP_AUTH0_AUDIENCE}
            scope="read:current_user"
            redirectUri={redirectUri}
        >
            <TealiumUTagLoader />
            <ServiceProvider deployType={deployType} tenantSlug={tenantSlug} alternateTheme={alternateTheme}>
                {children}
            </ServiceProvider>
        </Auth0Provider>
    );
};
